var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hic-dialog',{attrs:{"title":"病历详情","close-on-click-modal":false,"visible":_vm.visible,"append-to-body":"","width":"54rem","top":"4vh","hide-footer":""},on:{"close":_vm.cancel}},[_c('el-row',{staticStyle:{"min-height":"40rem"}},[_c('emr-info-panel',{attrs:{"op-no":_vm.opNo}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }